<template>
  <section>
    <h1 class="section-head">ตั้งค่าซัพพลายเออร์</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-success is-pulled-right" to="supplier/add" v-can="'add_supplier'"><i class="fas fa-plus"></i>เพิ่ม</router-link>
          </div>
        </div>
      </div>
    </nav>

    
    <b-table
      :data="filteredData" 
      selectable @click="selected" 
      :columns="columns" 
      :selected.sync="selectedItem" 
      ref="loadingElement"

      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :narrowed="true"
      @page-change="onPageChange"
    >
    </b-table>
    <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
    <div class="notification has-text-centered" v-if="(all_supplier.length == 0) && !isLoading">ไม่พบข้อมูล</div>
  </section>
</template>

<script>
  import Request from '@/libraries/request'

  export default {
    name: 'Product',
    data() {
      return {
        all_supplier: [],
        columns: [{
            field: 'id',
            label: 'ID',
            width: '40',
            numeric: true
          },
          {
            field: 'name',
            label: 'Supplier Name',
          },
          {
            field: 'address',
            label: 'Address'
          },
          {
            field: 'phone',
            label: 'Phone',
          },
          {
            field: 'email',
            label: 'E-mail',
          }
        ],
        selectedItem: {},
        lastSelected: {},
        isLoading: true,
        loadingComponent: null,

        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    created() {
      this.init();

    },
    mounted() {
      // this.loadingComponent = this.$loading.open({
      //               container: this.$refs.loadingElement.$el
      //           });
    },
    computed: {
      filteredData: function() {
        return this.all_supplier.filter(supplier => {
          return (
                  (supplier.address && supplier.address.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (supplier.phone && supplier.phone.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (supplier.email && supplier.email.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (supplier.name && supplier.name.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      }
    },
    methods: {
      selected(item) {
        if(!this.can("add_supplier|edit_supplier|delete_supplier|view_supplier")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/supplier/view/'+item.id })
        }
        this.lastSelected = item;
      },
      init() {
        Request.get('supplier',(res) => {
          // this.loadingComponent.close();
          this.isLoading = false;
          if(res.data.status){
            this.all_supplier = res.data.data;
          }
        });
      },
      onPageChange(page){
        this.scrollTo({ 
          to: 'body'
        });
      }
    }
  }

</script>

<style lang="scss">
  table tbody {
    tr:hover {
      background-color: #F7F7F7;
    }
    .is-selected {
      cursor: pointer;
    }
  }

 

</style>



// WEBPACK FOOTER //
// src/pages/Supplier/index.vue